import { createReduxActionTypes } from '../../../utils/actionFactory';

const SET_CRD_HOOKS = 'SET_CRD_HOOKS';
const RESET_CRD_HOOKS = 'RESET_CRD_HOOKS';
const SET_COLUMNS = 'SET_COLUMNS';

export const actionTypes = createReduxActionTypes('CRD_HOOKS', [
  SET_CRD_HOOKS,
  RESET_CRD_HOOKS,
  SET_COLUMNS
]);

const DEFAULT_STATE = {
  cdrHooks: [],
  columns: []
};

export const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes[SET_CRD_HOOKS]: {
      return { ...state, cdrHooks: [...action.cdrHooks] };
    }
    case actionTypes[SET_COLUMNS]: {
      return { ...state, columns: [...action.columns] };
    }
    case actionTypes[RESET_CRD_HOOKS]: {
      return { ...DEFAULT_STATE };
    }
    default:
      return state;
  }
};

export const actions = {
  setCdrHooks: cdrHooks => ({
    type: actionTypes[SET_CRD_HOOKS],
    cdrHooks
  }),
  setColumns: columns => ({
    type: actionTypes[SET_COLUMNS],
    columns
  }),
  resetCdrHooks: () => ({ type: actionTypes[RESET_CRD_HOOKS] })
};
